class CarStatusData {
    static data() {
        return {
            on_way: {slug: "on_way", label: "В пути", short_label: "", class: "on_way"},
            in_salon: {slug: "in_salon", label: "На площадке", short_label: "", class: "in_salon"},
            in_service: {slug: "in_service", label: "В сервисе", short_label: "", class: "in_service"},
            reserved: {slug: "reserved", label: "Резерв", short_label: "", class: "reserved"},
            sold: {slug: "sold", label: "Продан", short_label: "", class: "sold"},
            recalled: {slug: "recalled", label: "Отозван", short_label: "", class: "recalled"},
        };
    }
    static dataAsArray() {
        let arr = [];
        let data = this.data();
        for (status in data) {
            arr.push(data[status])
        }
        return arr;
    }
    static forSelect() {
        return this.dataAsArray().map(function (item) {
            return {id: item.slug, text: item.label};
        })
    }
}

export default CarStatusData;
